
<template>
    <div id="header-menu">
        
        <span class="text-logo">
            <RouterLink to="/">
                <img src="../assets/podiso_textlogo.png" height="80"/>
            </RouterLink>
        </span>
        <br/>
    
    
        <span class="item">
            <a href="https://medium.com/pocketdimensionsociety">Posts</a>
        </span>
    
        <span class="item">
            <a href="https://www.redbubble.com/people/DimensionShop/shop">Shop</a>
        </span>
    
        <span class="item">
            <RouterLink to="/about">
                About Us
            </RouterLink>
        </span>
    </div>
</template>
